export default __webpack_public_path__ + "static/media/circleIcon.2750071a.svg";